var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_8566_32092)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8566_32092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 38.3331H48.1002L42.0502 31.0665C41.7673 30.7261 41.6312 30.2873 41.6718 29.8466C41.7124 29.4059 41.9265 28.9994 42.2668 28.7165C42.6072 28.4336 43.046 28.2975 43.4867 28.3381C43.9274 28.3787 44.3339 28.5928 44.6168 28.9331L52.9502 38.9331C53.0062 39.0127 53.0564 39.0962 53.1002 39.1831C53.1002 39.2665 53.1002 39.3165 53.2168 39.3998C53.2924 39.5909 53.3319 39.7943 53.3335 39.9998C53.3319 40.2053 53.2924 40.4087 53.2168 40.5998C53.2168 40.6831 53.2168 40.7331 53.1002 40.8165C53.0564 40.9034 53.0062 40.9869 52.9502 41.0665L44.6168 51.0665C44.4601 51.2546 44.2639 51.4059 44.0421 51.5096C43.8203 51.6133 43.5783 51.6669 43.3335 51.6665C42.9441 51.6672 42.5667 51.5316 42.2668 51.2831C42.0981 51.1432 41.9586 50.9714 41.8563 50.7775C41.7541 50.5836 41.6911 50.3714 41.6709 50.1531C41.6508 49.9348 41.6739 49.7147 41.739 49.5053C41.8041 49.296 41.9098 49.1016 42.0502 48.9331L48.1002 41.6665H28.3335C27.8915 41.6665 27.4675 41.4909 27.155 41.1783C26.8424 40.8658 26.6668 40.4418 26.6668 39.9998C26.6668 39.5578 26.8424 39.1339 27.155 38.8213C27.4675 38.5087 27.8915 38.3331 28.3335 38.3331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8566_32092",
    x1: 80,
    y1: 80,
    x2: 15.4604,
    y2: 68.9532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E15404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9050"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8566_32092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextimg);
export default __webpack_public_path__ + "static/media/nextimg.7f4b6851485e1691193e73e4b952cd46.svg";
export { ForwardRef as ReactComponent };